import { Route, Redirect } from "react-router";
import can from "lib/permissions/can";
import { useAuth } from "components/common/AuthProvider";
import { isReferralPath, referralBounceTarget } from "components/Referral/journeyPath";

export default ({
  currentUser: standardUser,
  permission,
  redirectTo,
  component: Component,
  layout: Layout,
  location,
  ...rest
}) => {
  // CD-8740: `referralUser` rather than `user` — the context's `user` now covers
  // both journeys, and this guard's "anonymous" branch means the referral one.
  const { referralUser: anonymousUser } = useAuth();

  return (
    <Route
      {...rest}
      render={props => {
        // Referral journey pages derive their bounce target from the brand in the URL, so a
        // comms customer without a session lands on the comms lookup page, not the energy one.
        const pathname = redirectTo || referralBounceTarget(props.location.pathname) || "/signin";
        const search = `?url=${encodeURIComponent(`${props.location.pathname}${props.location.search}`)}`;
        const hasPermission = permission === undefined || can(standardUser)(permission);

        // No user exists
        if (!standardUser && !anonymousUser) {
          return <Redirect to={{ pathname, search }} />
        }

        // standard user exists but does not have permission
        if (standardUser && !hasPermission) {
          return <Redirect to={{ pathname: "/not-found", search }} />
        }

        // Anonymous customers are allowed through the referral journey. isReferralPath accepts
        // the brand-prefixed shape as well as the legacy /referral one.
        if (!standardUser && !isReferralPath(location.pathname)) {
          return <Redirect to={{ pathname, search }} />
        }

        return Layout === undefined ? (
          <Component {...props} />
        ) : (
          <Layout>
            <Component {...props} />
          </Layout>
        )
      }
    }
    />
  )
};